export enum ChannelTypeEnum {
  DECRIM = "file.featureDecrim",
  LABOR_CERTIFICATION = "file.laborCertification",
  PAYROLLCHECK = "file.featurePayrollCheck",
  TRAINING = "file.featureTraining",
}
